import { AgmCoreModule } from '@agm/core';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { GoogleMapsConfig } from './google-maps.interface';
import { MapDirectionsDirective } from './map-directions.directive';

@NgModule({
  declarations: [MapDirectionsDirective],
  exports: [AgmCoreModule, MapDirectionsDirective],
})
export class GoogleMapsModule {
  static forRoot(
    mapsConfig: GoogleMapsConfig,
  ): ModuleWithProviders<AgmCoreModule> {
    return AgmCoreModule.forRoot(mapsConfig);
  }
}
